<template>
  <div
    class="CheckHiringComponent"
    :class="{ selected: innerValue }"
    @click="toggleValue"
    @keydown.enter.prevent="toggleValue"
    @keydown.space.prevent="toggleValue"
  >
    <div class="main-text">
      <input
        :id="id"
        class="checkbox"
        type="checkbox"
        :checked="innerValue"
        @click.stop
        @change="onInputChange"
      />
      <label
        :for="id"
        @click.stop
      >
        {{ label }}
      </label>
    </div>
    <div
      v-if="hint"
      class="secondary-text"
    >
      <ul>
        <li>
          {{ hint }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, watchEffect } from 'vue'

  const props = defineProps({
    label: String,
    hint: String,
    modelValue: Boolean,
    id: String
  })

  const innerValue = ref(props.modelValue)

  watchEffect(() => {
    innerValue.value = props.modelValue
  })

  const emit = defineEmits(['update:modelValue'])

  function toggleValue() {
    innerValue.value = !innerValue.value
    emit('update:modelValue', innerValue.value)
  }

  function onInputChange(event: Event) {
    const target = event.target as HTMLInputElement
    innerValue.value = target.checked
    emit('update:modelValue', innerValue.value)
  }
</script>

<style lang="scss" scoped>
  .CheckHiringComponent {
    cursor: pointer;
    background-color: $color-neutral-lighter;
    border: solid 1px $color-neutral-light;
    padding: $spacing-xl $spacing-s $spacing-xl $spacing-xl;

    & .main-text {
      display: flex;
      align-items: center;
      gap: $gap-s;
      cursor: pointer;
    }

    &.selected {
      color: $color-primary;
      border: 1.5px solid $color-primary;
      border-radius: $b-radius-2;
      background-color: $color-primary-lighter;
    }

    input {
      width: $size-16;
      height: $size-16;
      margin-right: $padding-5;
      accent-color: $color-primary;
      box-shadow: $box-shadow-0;
      clip-path: circle(100%);
      cursor: pointer;

      &:hover {
        box-shadow: 0 0 0 10px hsl(219deg 100% 69% / 10%);

        &:checked {
          animation: pulse 0.8s ease-in-out;
        }
      }
    }

    label {
      color: $color-neutral-dark;
    }
  }
</style>
